var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarDealsClosed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 13,
  viewBox: "0 0 9 13",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.8866 1.02757C0.565457 1.13071 0.312293 1.36747 0.15055 1.71674C-0.0111937 2.06835 -0.00416139 1.74252 0.00287093 7.11756C0.00990326 11.7566 0.0122474 11.9699 0.0520972 12.0941C0.197432 12.5207 0.50451 12.8278 0.910041 12.9474C1.0249 12.9802 1.37652 12.9849 4.21758 12.9849C7.05864 12.9849 7.41025 12.9802 7.52511 12.9474C7.93768 12.8255 8.25179 12.509 8.38306 12.0824C8.42291 11.9488 8.42525 11.7308 8.42525 6.99567C8.42525 2.85597 8.42056 2.0285 8.39243 1.92068C8.28226 1.48467 7.95877 1.14946 7.52511 1.02054C7.41025 0.98772 7.07504 0.983032 4.2082 0.985375C1.21477 0.985375 1.01084 0.98772 0.8866 1.02757ZM6.30383 5.96192C6.8125 6.09553 7.15943 6.61123 7.07973 7.11991C6.96018 7.88174 6.11162 8.26383 5.47167 7.83955C4.99113 7.52075 4.86221 6.87846 5.18101 6.40026C5.42948 6.0299 5.88189 5.85174 6.30383 5.96192Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarDealsClosed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_deals_closed.2eb0ff7a8b24ed34d48d18160ecef899.svg";